import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, take } from 'rxjs/operators';
import { Chamado } from 'src/app/modules/painel/modules/chamados/interfaces/chamado';
import { ChamadosService } from 'src/app/modules/painel/modules/chamados/services/chamados.service';
import { AlertService } from 'src/app/shared/alert/alert.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chamados-list-cliente',
  templateUrl: './chamados-list-cliente.component.html',
  styleUrls: ['./chamados-list-cliente.component.scss']
})
export class ChamadosListClienteComponent implements OnInit, OnDestroy {

  constructor(
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private chamadoService: ChamadosService
  ) { }

  chamados: Chamado[] = [];
  timer = null;

  ngOnInit() {
    this.spinner.show();

    this.getChamados();

    this.timer = setInterval(() => { this.getChamados() }, 30000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  private getChamados() {
    this.chamadoService.getAbertos()
      .pipe(take(1), finalize(() => this.spinner.hide()))
      .subscribe(chamados => {
        this.chamados = chamados.map(chamado => {
          const equipamentos = chamado.ordens_servico.map(ticket => ({ ...ticket.equipamento }));
          const posicionamentos = chamado.ordens_servico.flatMap(ticket => ticket.posicionamentos);

          return {
            ...chamado,
            equipamentos: equipamentos,
            nomeTecnicos: chamado.tecnicos.length ? chamado.tecnicos.map(tecnico => tecnico.nome).join(', ') : 'Não atribuído',
            posicionamentosString: posicionamentos.map(posicionamento => `${moment(posicionamento.created_at).format('DD/MM/yy HH:mm')}: ${posicionamento.descricao}`).join('<br><br>')
          };
        });
      }, (error: HttpErrorResponse) => {
        this.alertService.error(error.error, error.status);
      });
  }

  visualizarPosicionamentos(posicionamentosString: string) {
    Swal.fire({
      html: posicionamentosString,
      confirmButtonText: 'Fechar'
    });
  }
}
